import { Component, NgZone, OnInit, OnDestroy } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { NgHttpLoaderModule, Spinkit } from "ng-http-loader";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, NgHttpLoaderModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit, OnDestroy {
  public spinkit = Spinkit;
  private observer: MutationObserver | null = null;

  constructor(private ngZone: NgZone) {}

  ngOnInit() {
    if (typeof window !== "undefined") {
      this.ngZone.runOutsideAngular(() => {
        this.observer = new MutationObserver(() => {
          this.checkPopups();
        });

        this.observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class", "style"],
        });

        // Run once initially
        this.checkPopups();
      });
    }
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private checkPopups() {
    const popups = document.querySelectorAll(".popup-wrapper");
    let hasVisiblePopup = false;

    for (let i = 0; i < popups.length; i++) {
      const el = popups[i] as HTMLElement;
      if (el.offsetWidth > 0 || el.offsetHeight > 0) {
        if (!el.classList.contains("hidden")) {
          hasVisiblePopup = true;
          break;
        }
      }
    }

    if (hasVisiblePopup) {
      if (!document.body.classList.contains("popup-open")) {
        document.body.classList.add("popup-open");
      }
    } else {
      if (document.body.classList.contains("popup-open")) {
        document.body.classList.remove("popup-open");
      }
    }
  }
  // checkStatus = () => {
  //   const threshold = 160;
  //   const widthThreshold = window.outerWidth - window.innerWidth > threshold;
  //   const heightThreshold = window.outerHeight - window.innerHeight > threshold;
  //   if (widthThreshold || heightThreshold) {
  //     window.location.replace("about:blank");
  //   }
  // };
  // constructor() {
  //   setInterval(this.checkStatus, 100);
  //   setInterval(() => {
  //     console.clear();
  //     window.close();
  //   }, 200);
  // }

  // @HostListener("document:contextmenu", ["$event"])
  // onRightClick(event: MouseEvent) {
  //   event.preventDefault();
  // }

  // @HostListener("document:keydown", ["$event"])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   if (
  //     (event.ctrlKey && (event.key === "u" || event.key === "U")) || 
  //     (event.ctrlKey &&
  //       event.shiftKey &&
  //       (event.key === "i" || event.key === "I")) || 
  //     (event.ctrlKey &&
  //       event.shiftKey &&
  //       (event.key === "c" || event.key === "C")) || 
  //     (event.ctrlKey &&
  //       event.shiftKey &&
  //       (event.key === "j" || event.key === "J")) || 
  //     event.key === "F12"
  //   ) {
  //     event.preventDefault();
  //   }
  // }

  // ngOnInit() {}
}
